import { createContext } from 'react'

export interface AriaHiddenContextType {
  hideBackground: () => void
  showBackground: () => void
  isBackgroundHidden: () => boolean
}

export const AriaHiddenContext = createContext<AriaHiddenContextType | undefined>(undefined)
